import lazyLoad from '@/utils/lazyLoad';
import { IRoute } from '@/router/typings';
import { MobileDefaultPage } from './mobileDefaultPage';

const baseRoutes: IRoute[] = [
  {
    name: '首页',
    path: '/home',
    component: lazyLoad(() => import('@/pages/mobilePage/home')),
  },
  {
    name: '请假个人申请',
    path: '/leave/apply',
    component: lazyLoad(() => import('@/pages/mobilePage/leave/LeaveApply')),
  },
  {
    name: '请假个人申请',
    path: '/leave/apply/:leaveId',
    component: lazyLoad(() => import('@/pages/mobilePage/leave/LeaveApply')),
  },
  {
    name: '休假记录',
    path: '/leave/manage',
    component: lazyLoad(() => import('@/pages/mobilePage/leave/LeaveList')),
  },
  {
    name: '休假详情',
    path: '/leave/manage/detail/:id',
    component: lazyLoad(() => import('@/pages/mobilePage/leave/LeaveDetail')),
  },
  {
    name: '公出详情',
    path: '/leave/out-official/detail/:id',
    component: MobileDefaultPage,
  },
  {
    name: '离职申请',
    path: '/resign/apply',
    component: lazyLoad(
      () => import('@/pages/mobilePage/resign/MobileResignApply')
    ),
  },
  {
    name: '离职申请记录',
    path: '/resign/list',
    component: lazyLoad(
      () => import('@/pages/mobilePage/resign/MobileResignList')
    ),
  },
  {
    name: '人事申请-离职审批详情',
    path: '/people/staff-apply/resign/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/resign/MobileResignDetail')
    ),
    ignore: true,
  },
  {
    name: '离职管理-离职审批详情',
    path: '/people/resign/apply/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/resign/MobileResignDetail')
    ),
    ignore: true,
  },
  {
    name: '人事申请-在职信息采集详情',
    path: '/people/staff-apply/collect/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/collect/MobileCollectApplyDetail')
    ),
  },
  {
    name: '人事申请-转正详情',
    path: '/people/staff-apply/regular/:id',
    component: MobileDefaultPage,
  },
  {
    name: '花名册-在职信息采集详情',
    path: '/people/roster/collect/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/collect/MobileCollectApplyDetail')
    ),
  },
  {
    name: '我的考勤',
    path: '/attendance/my-attendance',
    component: lazyLoad(
      () => import('@/pages/mobilePage/attendance/MobileAttendanceTransfer')
    ),
  },
  {
    name: '补卡',
    path: '/attendance/my-attendance/replace-card-apply',
    component: lazyLoad(
      () => import('@/pages/mobilePage/attendance/MobileReplaceCardApply')
    ),
  },
  {
    name: '我的补卡记录',
    path: '/attendance/my-replace-card',
    component: lazyLoad(
      () => import('@/pages/mobilePage/attendance/MobileMyReplaceCardList')
    ),
  },
  {
    name: '排班考勤日历',
    path: '/attendance/schedule-calendar',
    component: lazyLoad(
      () => import('@/pages/mobilePage/attendance/MobileScheduleCalendar')
    ),
  },
  {
    name: '花名册',
    path: '/people/roster',
    component: lazyLoad(() => import('@/pages/mobilePage/Roster')),
  },
  {
    name: '花名册详情',
    path: '/people/roster/detail/:id',
    component: lazyLoad(() => import('@/pages/mobilePage/Roster/RosterDetail')),
  },
  {
    name: '简历筛选',
    path: '/recruitment/resume-screening',
    component: lazyLoad(() => import('@/pages/mobilePage/recruitment/Detail')),
  },
  {
    name: '内推助手',
    path: '/internalRecommendation',
    component: lazyLoad(
      () => import('@/pages/mobilePage/InternalRecommendation')
    ),
  },
  {
    name: '我的内推',
    path: '/internalRecommendation/record',
    component: lazyLoad(
      () => import('@/pages/mobilePage/InternalRecommendation/MyRecord')
    ),
  },
  {
    name: '职位详情',
    path: '/internalRecommendation/position-detail/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/InternalRecommendation/Detail')
    ),
  },
  {
    name: '加班申请',
    path: '/attendance/overtime/apply',
    component: lazyLoad(
      () => import('@/pages/mobilePage/overtime/OvertimeApply')
    ),
  },
  {
    name: '加班申请详情',
    path: '/attendance/overtime/detail/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/overtime/OvertimeDetail')
    ),
  },
  {
    name: '加班申请记录',
    path: '/attendance/overtime/list',
    component: lazyLoad(
      () => import('@/pages/mobilePage/overtime/OvertimeList')
    ),
  },
  {
    name: '出差申请',
    path: '/out-business/apply',
    component: lazyLoad(
      () => import('@/pages/mobilePage/outBusiness/OutBusinessApply')
    ),
  },
  {
    name: '出差申请记录',
    path: '/out-business/list',
    component: lazyLoad(
      () => import('@/pages/mobilePage/outBusiness/OutBusinessList')
    ),
  },
  {
    name: '出差详情',
    path: '/leave/out-business/detail/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/outBusiness/OutBusinessDetail')
    ),
  },
  {
    name: 'HC审批详情',
    path: '/recruitment/hc/detail/:id',
    component: lazyLoad(() => import('@/pages/mobilePage/Hc/HcDetail')),
  },
  {
    name: '候选人详情',
    path: '/recruitment/candidate',
    component: lazyLoad(() => import('@/pages/mobilePage/recruitment/Detail')),
  },

  {
    name: '面试管理',
    path: '/recruitment/interview',
    component: lazyLoad(() => import('@/pages/mobilePage/recruitment/Detail')),
  },

  {
    name: '候选人详情', //offer 审批
    path: '/recruitment/offer-audit',
    component: lazyLoad(() => import('@/pages/mobilePage/recruitment/Detail')),
  },

  {
    name: '请跳转PC端查看',
    path: '/default',
    component: MobileDefaultPage,
  },
  {
    name: '转正申请详情',
    path: '/people/regular/apply/:id',
    component: MobileDefaultPage,
  },
  {
    name: '职位详情',
    path: '/recruitment/position/detail/:id',
    component: MobileDefaultPage,
  },
  {
    name: '入职准备-待办',
    path: '/people/entry/todo',
    component: MobileDefaultPage,
  },
  // {
  //   name: '薪资管理',
  //   path: '/salary/increase/apply/:id',
  //   component: MobileDefaultPage,
  // },
  {
    name: '调薪申请详情',
    path: '/salary/increase/apply/:id',
    component: lazyLoad(() => import('@/pages/mobilePage/salary/salaryDetail')),
  },
  {
    name: '试岗期管理',
    path: '/people/trial',
    component: MobileDefaultPage,
  },
  {
    name: '调班申请',
    path: '/attendance/shift-transfer/apply',
    component: lazyLoad(
      () => import('@/pages/mobilePage/shiftManage/shiftApply')
    ),
  },
  {
    name: '调班申请详情',
    path: '/attendance/shift-transfer/detail/:id',
    component: lazyLoad(
      () => import('@/pages/mobilePage/shiftManage/shiftDetail')
    ),
  },
  {
    name: '调班列表',
    path: '/attendance/shift-transfer/list',
    component: lazyLoad(
      () => import('@/pages/mobilePage/shiftManage/shiftList')
    ),
  },
  {
    name: '绩效首页-绩效待办',
    path: '/performance/home/todo',
    component: MobileDefaultPage,
  },
  {
    name: '绩效-我的绩效',
    path: '/performance/my/detail',
    component: MobileDefaultPage,
  },
  {
    name: '绩效-申诉审核',
    path: '/performance/appeal-approval',
    component: MobileDefaultPage,
  },
  {
    name: '月度绩效',
    path: '/performance/month',
    component: MobileDefaultPage,
  },
  {
    name: '调动申请',
    path: '/people/transfer/apply/:id',
    component: MobileDefaultPage,
  },
];

export default baseRoutes;
